export default __webpack_public_path__ + "static/media/WIEDZA.6c53a1f2.png";